import React from "react";

/**
 * Reusable animated placeholder grid while data is loading.
 *
 * Props:
 *  - count        number   — number of skeleton items (default 8)
 *  - itemClassName string  — height / extra classes per item (default "h-40")
 *  - gridClassName string  — grid layout classes
 */
export default function SkeletonGrid({
  count = 8,
  itemClassName = "h-40",
  gridClassName = "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4",
}) {
  return (
    <div className={gridClassName}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className={`rounded-2xl bg-gray-200 animate-pulse ${itemClassName}`} />
      ))}
    </div>
  );
}
